import { render, staticRenderFns } from "./myHome.vue?vue&type=template&id=19604158&scoped=true"
import script from "./myHome.vue?vue&type=script&lang=js"
export * from "./myHome.vue?vue&type=script&lang=js"
import style0 from "./myHome.vue?vue&type=style&index=0&id=19604158&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19604158",
  null
  
)

export default component.exports